import React, { useEffect, useState } from 'react'; 
import axios from 'axios';
import { COURSES_URL, ENROLLMENT_URL } from '../../Services/courseService';
import CourseTemplate from './CourseTemplate';
import ClipLoader from 'react-spinners/ClipLoader';
import { useTranslation } from 'react-i18next';

const RecentlyCompletedCourses = () => {
     const [recentlyCompletedCourses, setRecentlyCompletedCourses] = useState([]);
    const [loading, setLoading] = useState(true);
    const userId = localStorage.getItem('userId');
    const { t } = useTranslation(); 

    useEffect(() => {
        const loadEnrollments = async () => {
            setLoading(true);
            try {
                const res = await axios.get(`${ENROLLMENT_URL}/${userId}/enrollments`);
                const resJson = res?.data;
 
                const currentDate = new Date();
                const recentCompleted = resJson?.filter(course => {
                    const completedDate = new Date(course?.completedAt);
                    const timeDiff = currentDate - completedDate;
                    const daysDiff = timeDiff / (1000 * 3600 * 24);
                    return course?.status === "COMPLETED" && daysDiff <= 60;
                });

                const courseDetails = await Promise.all(recentCompleted?.map(async (course) => {
                    const courseDetailsResponse = await axios.get(`${COURSES_URL}/course/${course?.courseId}`);
                    return {
                        ...course,
                        title: courseDetailsResponse?.data?.data?.title,
                        description: courseDetailsResponse?.data?.data?.description,
                        imageUrl: courseDetailsResponse?.data?.data?.imageUrl,
                        price: courseDetailsResponse?.data?.data?.price,
                        createdBy: courseDetailsResponse?.data?.data?.createdBy,
                        // progressStatus:  courseDetailsResponse?.data?.data?.status,
                    };
                }));

                const uniqueCourses = Array.from(new Set(courseDetails?.map(course => course?.courseId)))
                    ?.map(id => courseDetails?.find(course => course?.courseId === id));

                setRecentlyCompletedCourses(uniqueCourses);
            } catch (error) {
                console.error("Error loading enrollments:", error);
            } finally {
                setLoading(false);
            }
        };

        if(userId){
        loadEnrollments();
        }else{
            setLoading(false);
          }
    }, [userId]);

    return (
        <div>
            {loading ? (
                <ClipLoader color="#333333" loading={loading} size={30} id='clipLoader' />
            ) : recentlyCompletedCourses?.length > 0 && (
                <CourseTemplate
                    coursesData={recentlyCompletedCourses}
                    pageTitle={t(`${`Recently Completed Courses`}`)}
                />
            ) }
        </div>
    );
};

export default RecentlyCompletedCourses;

